import { useState } from 'react';
import './App.css';
import Preview from './components/Preview';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getSignatureHtml } from './helpers';

function App() {
  const [fullName, setFullname] = useState<string>('Name Surname');
  const [position, setPosition] = useState<string>('Position');
  const [phone, setPhone] = useState<string>('+374-12 34-56-78');
  const [email, setEmail] = useState<string>('name.surname@telcell.am');

  const onFullNameChangeHandeler = (e: React.ChangeEvent<HTMLInputElement>) => setFullname(e.target.value);
  const onPositionChangeHandeler = (e: React.ChangeEvent<HTMLInputElement>) => setPosition(e.target.value);
  const onPhoneChangeHandeler = (e: React.ChangeEvent<HTMLInputElement>) => setPhone(e.target.value);
  const onEmailChangeHandeler = (e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value);

  const onZimbraCopyHandeler = () => {
    navigator.clipboard.writeText(getSignatureHtml({fullName, position, email, phone}).trim());
    toast("Copied to clipboard", { autoClose: 2000})
  };

  const onGmailCopyHandeler = () => {
    const html = getSignatureHtml({fullName, position, email, phone}).trim();
    const clipboardItem = new
        ClipboardItem({'text/html':  new Blob([html],
                                              {type: 'text/html'}),
                       'text/plain': new Blob([html],
                                              {type: 'text/plain'})});
    navigator.clipboard.write([clipboardItem]).then(_ => toast("Copied to clipboard", { autoClose: 2000}));
  };

  return (
    <div className="container">
      <form>
        <div className="form-group">
          <label>Full name</label>
          <input value={fullName} onChange={onFullNameChangeHandeler} placeholder='Full name' />
        </div>
        <div className="form-group">
          <label>Position</label>
          <input value={position} onChange={onPositionChangeHandeler} placeholder='Position' />
        </div>
        <div className="form-group">
          <label>Phone number</label>
          <input value={phone} onChange={onPhoneChangeHandeler} placeholder='Phone' />
        </div>
        <div className="form-group">
          <label>Email</label>
          <input value={email} onChange={onEmailChangeHandeler} placeholder='Email' />
        </div>
      </form>
      
      <Preview fullName={fullName} position={position} phone={phone} email={email} />

      <div style={{display: 'flex', gap: 10}}>
        <button onClick={onZimbraCopyHandeler}>Copy for Zimbra</button>
        <button onClick={onGmailCopyHandeler}>Copy for Gmail</button>
      </div>


      <ToastContainer />

    </div>
  );
}

export default App;
